import { IFile, IMessage, IPatchResponse, ITemplateField, IUserClient } from '@leandredev/dcbm-common-lib/dist/interfaces';

export type defaultType = { id: string; class: string };
export interface IAdminChat {
  picture: IFile;
  name: string;
  profile: IUserClient;
  messages: IMessage[];
  lastMessageTime: Date;
  lastMessage: string;
  skiped: number;
  unreadMessage: IMessage[];
  hasPreviousMessages: boolean;
}

export interface I_Message_Data {
  _type: string;
  regroupedFields?: ITemplateField[];
}

const ADDRESS_KEYS = {
  street_number: 'Numéro de rue',
  complement: `Complément d'adresse`,
  city: 'Ville',
  administrative_area: 'Département',
  zipcode: 'Code Postal',
  country: 'Pays'
};

const PERSON_KEYS = {
  civility: 'Civilité',
  name: 'Nom',
  surname: 'Prénom',
  birthdate: 'Date de naissance',
  birthplace: 'Lieu de naissance',
  address: 'Adresse',
  postcode: 'Code Postal',
  city: 'Ville',
  phone: 'Téléphone',
  email: 'Email',
  information: 'Information'
};

const DATE_KEYS = ['birthdate'];

export function _parseExtendedRequestMessage(data: IPatchResponse): string[] {
  try {
    const value: string | object = JSON.parse(data.field.value) as string | object;

    if (typeof value == 'object') {
      return selectType(value as { _type: string });
    }
  } catch (e) {
    return [data.field.value];
  }

  return [data.field.value];
}

function selectType(value: { _type: string }): string[] {
  if (value._type === 'address') {
    const res: string[] = [];

    Object.keys(ADDRESS_KEYS).forEach((key) => {
      let _v: string = value[key] as string;

      if (DATE_KEYS.includes(key)) {
        _v = new Date(_v).toLocaleDateString('fr');
      }

      const t = ADDRESS_KEYS[key] as string;
      res.push(`${t}: ${_v} \n`);
    });

    return res;
  }

  if (value._type === 'person') {
    const res: string[] = [];

    Object.keys(PERSON_KEYS).forEach((key) => {
      let _v: string = value[key] as string;

      if (DATE_KEYS.includes(key)) {
        _v = new Date(_v).toLocaleDateString('fr');
      }
      const t = PERSON_KEYS[key] as string;
      res.push(`${t}: ${_v} \n`);
    });

    return res;
  }
}
